import React, { Component } from 'react';

class Header extends Component{
  render() {
    return (
      <thead>
        {this.props.children}
      </thead>
    );
  }
}

export default Header;
